import axios from 'axios';
import { PUBLIC_API_URL_ENV } from './environments';

export const api = axios.create({
    baseURL: PUBLIC_API_URL_ENV,
    withCredentials: true,
    headers: {
        'Content-Type': 'application/json',
    },
});
